module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "dune.50851a55.svg";